import CurrencyAdjustedValueViewer from 'components/Spreadsheet/components/CurrencyAdjustedValueViewer';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

export interface UpdateCostCellsIfDifferentParams {
  currencyAdjustedValueViewerCells: string[];
  isDifferentCurrency: boolean;
  parsedCells: { [key: string]: ICell };
  cell: ICell;
  relatedDateAlias: string;
}

const updateCostCellsIfDifferent = ({
  currencyAdjustedValueViewerCells,
  isDifferentCurrency,
  parsedCells,
  cell,
  relatedDateAlias = 'date',
}: UpdateCostCellsIfDifferentParams) => {
  if (currencyAdjustedValueViewerCells.includes(cell.alias) && isDifferentCurrency) {
    const relatedDate = parsedCells?.[`${relatedDateAlias}${cell.rowNumber! + 1}`]?.value;
    return {
      ...cell,
      valueViewer: CurrencyAdjustedValueViewer,
      relatedDate,
    };
  }
  return cell;
};

export default updateCostCellsIfDifferent;
